var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[_c('Content',{staticClass:"app-content__main"},[_c('order-chart')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }